import { makeAutoObservable, runInAction } from 'mobx';

import { basketAjaxController } from "../Ajax/BasketAjaxController";
import { StockistBasketDTO } from "../DTOs/Basket/StockistBasketDTO";
import { StockistBasketItemDTO } from "../DTOs/Basket/StockistBasketItemDTO";
import { stockiestPortalController } from './StockiestPortalController';
import { userAccountController } from "./UserAccountController";

export class BasketController {
  basketAjaxController = basketAjaxController;
  private _basket: StockistBasketDTO | null = null
  private _isBasketDataLoading = false;

  //#region Data Fetchers
  async getBasket() {
    if (this._basket || !userAccountController.isLoggedIn) return;

    this._isBasketDataLoading = true

    try {
      const basket: StockistBasketDTO | null = await this.basketAjaxController.getBasket();

      runInAction(() => {
        this._basket = basket;
        stockiestPortalController.orderedProducts = basket?.items ?? [];
      });
    } catch (error) {
    } finally {
      runInAction(() => {
        this._isBasketDataLoading = false;
      });
    }
  }

  //#endregion

  get basket() {
    return this._basket
  }

  get isBasketDataLoading() {
    return this._isBasketDataLoading
  }

  clearBasket() {
    this._isBasketDataLoading = true
    this._basket = null;
    stockiestPortalController.orderedProducts = [];
    this._isBasketDataLoading = false;
  }

  async addToBasket(issueId: number, quantity: number) {
    runInAction(() => this._isBasketDataLoading = true);

    try {
      const updatedBasket = await this.basketAjaxController.addToBasket(issueId, quantity)

      runInAction(() => {
        this._basket = updatedBasket;
        stockiestPortalController.orderedProducts = updatedBasket.items ?? [];
      })
    } catch (error) {
      throw new Error((error as Error).message + ` while adding issue ${issueId} to the basket`)
    } finally {
      runInAction(() => {
        this._isBasketDataLoading = false;
      });
    }
  }

  async removeFromBasket(item: StockistBasketItemDTO) {
    runInAction(() => this._isBasketDataLoading = true);

    try {
      const updatedBasket = await this.basketAjaxController.removeFromBasket(item.issueId)

      runInAction(() => {
        this._basket = updatedBasket;
        stockiestPortalController.orderedProducts = updatedBasket.items ?? [];
      })
    } catch (error) {
      throw new Error((error as Error).message + ` while removing ${item.issue.magazine.title} from the basket`)
    } finally {
      runInAction(() => {
        this._isBasketDataLoading = false;
      });
    }
  }

  async updateProduct(item: StockistBasketItemDTO, quantity: number) {
    runInAction(() => this._isBasketDataLoading = true);

    try {
      const updatedBasket = await this.basketAjaxController.updateBasket(item.issueId, quantity)

      runInAction(() => {
        this._basket = updatedBasket;
        stockiestPortalController.orderedProducts = updatedBasket.items ?? [];
      })
    } catch (error) {
      throw new Error((error as Error).message + ` while updating ${item.issue.magazine.title} in the basket`)
    } finally {
      runInAction(() => {
        this._isBasketDataLoading = false;
      });
    }
  }

  async updateBasketAddress(newAddressId: number) {
    if (!this._basket) return;

    runInAction(() => this._isBasketDataLoading = true);

    try {
      const updatedBasket = await this.basketAjaxController.updateBasketAddress(newAddressId);

      runInAction(() => {
        this._basket = updatedBasket;
        stockiestPortalController.orderedProducts = updatedBasket.items ?? [];
      });
    } catch (error) {
    } finally {
      runInAction(() => this._isBasketDataLoading = false);
    }
  }


  constructor() {
    makeAutoObservable(this);
  }
}

export const basketController = new BasketController();